import { FC } from "preact/compat";
import { useApp } from "~/core";
import { Button } from "~/components";
import { ContentEditorFooterProps } from "./interfaces";
import SaveIcon from "@material-design-icons/svg/outlined/save.svg";
import Loader from "~/assets/loader.svg";

const ContentEditorFooter: FC<ContentEditorFooterProps> = ({
    disabled,
    loading,
    onClick,
    children,
}) => {
    const { help } = useApp();
    const currentTag = help.admin.isGuide.value
        ? ""
        : help.admin.editorTag.value;
    const items = help.admin.unsaved.value
        .filter((i) => i.tag !== currentTag)
        .toReversed();

    return (
        <div className="sticky bottom-0 z-20 flex min-h-[67px] items-center justify-between border-t border-gray-300 bg-gray-100 p-4">
            <div className="flex items-center gap-x-4">
                {children ? (
                    children
                ) : (
                    <Button
                        variant="secondary"
                        disabled={disabled}
                        onClick={onClick}
                    >
                        {loading ? (
                            <Loader width="18" height="18" />
                        ) : (
                            <SaveIcon
                                width="18"
                                height="18"
                                className="mr-2 fill-current"
                            />
                        )}
                        <span className="ml-2">Save changes</span>
                    </Button>
                )}
            </div>
            {items.length > 0 && (
                <div className="-mb-2 flex items-center gap-x-2 whitespace-nowrap">
                    <span>Unsaved: </span>
                    <div className="overflow-x-overlay flex max-w-[740px] items-center gap-x-2">
                        {items.map((i) => (
                            <button
                                type="button"
                                key={i.tag}
                                onClick={() => help.admin.openEditor(i.tag)}
                                className="rounded-full border border-gray-500 px-2 py-1 text-sm hover:border-sky-500 hover:text-sky-500"
                            >
                                {i.tag}
                            </button>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default ContentEditorFooter;
